<template>
  <div class="user-nav-links">
    <button
      class="user-box"
      @click="toggleUserMenu"
    >
      <div class="user-avatar">
        <img
          src="@/assets/images/users/user-10.jpg"
          alt="user-image"
          class="rounded-circle"
        >
      </div>
      <div class="user-info">
        <p class="welcome-text">
          {{ userInfo.fullName }}
        </p>
      </div>
      <naj-icon icon="mdi mdi-chevron-down"></naj-icon>
    </button>
    <transition name="fade">
      <div
        v-if="userMenuVisible"
        class="user-megamenu-holder"
        @click.self="toggleUserMenu"
      >
        <div class="user-megamenu">
          <div class="manage-menu-header">
            <h6>
              {{ local.userMenuLinks.welcome }}
            </h6>
          </div>
          <div class="dropdown-divider" />

          <div class="user-links">
            <ul class="manage-menu-list">
              <li @click="logout">
                <v-icon>mdi-logout</v-icon>
                <span>{{ local.userMenuLinks.logOut }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('GlobalModule');
const { mapActions: mapAuthActions } = createNamespacedHelpers('AuthenticationModule');
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');
import { toHijriDateEnglishNumber } from '@/helpers/utils';

export default {
  name: 'NajHeaderMenu',
  data() {
    return { userMenuVisible: false };
  },
  mounted() {
    this.getUserInfo();
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['firstName', 'lastName']),
  },
  watch: {
    userInfo: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) this.addOrUpdateUserInfo(newValue);
      },
    },
  },

  methods: {
    ...mapActions(['getUserInfo']),
    ...mapComplaintsActions(['addOrUpdateComplainantData']),
    toggleUserMenu() {
      this.userMenuVisible = !this.userMenuVisible;
    },
    logout() {
      this.$router.push('/auth/logout');
    },
    addOrUpdateUserInfo(userInfo) {
      /*this code for test environment */
      if (!userInfo.familyName) userInfo.familyName = '-';
      if (!userInfo.firstName) userInfo.firstName = '-';
      if (!userInfo.mobile) userInfo.mobile = '-';
      this.addOrUpdateComplainantData({
        name: userInfo.fullName,
        firstName: userInfo.firstName,
        secondName: userInfo.middleName,
        thirdName: userInfo.thirdName,
        familyName: userInfo.familyName,
        mobileNo: userInfo.mobile,
        birthDate: toHijriDateEnglishNumber(userInfo.dateOfBirth),
        nationality: userInfo.nationalityDescription,
        gender: userInfo.gender,
      })
        .then((data) => {
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/partials/_vars.scss";
.user-box {
  margin-right: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  /*.user-avatar {
    width: 46px;
    height: 46px;
    border-radius: 5px;
    background-color: #ffeed1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #b3863c;
    font-size: 20px;
    margin-left: 10px;
  }*/
  .user-info {
    line-height: 1;
    text-align: right;

    .welcome-text {
      margin: 0;
      font-size: 16px;
      color: #6c757d;
      white-space: nowrap;
      text-overflow: ellipsis;
      @media (max-width: 1680px) {
        max-width: 200px;
      }
    }
    /* .username {
      font-size: 20px;
      font-weight: 500;
      color: #6c757d;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      @media (max-width: 1680px) {
        max-width: 200px;
      }
    }*/
    @media (max-width: 1470px) {
      .welcome-text,
      .username {
        display: none;
      }
    }
  }
  ::v-deep .icon {
    font-size: 16px;
    margin-right: 5px;
    padding: 0;
    border: none;
  }
  .rounded-circle {
    border-radius: 50% !important;
    height: 38px;
    width: 38px;
  }
}
.user-nav-links {
  float: left;
  position: relative;

  .user-box {
    margin: 5px 0;
    cursor: pointer;
  }

  .the-username {
    font-size: 18px;
    color: $matBlue;
    margin-right: 20px;
  }

  .user-links-icon {
    font-size: 22px;
    margin-right: 5px;
    color: $matBlue;
  }
}

.user-megamenu-holder {
  position: absolute;
  left: 0;
  top: 67px;
  width: 170px;
  height: auto;
  z-index: 1000;
  background-color: #fff;
  border-radius: 4px;
  padding-block: 8px;
  .user-megamenu {
    .manage-menu-header {
      font-weight: bold;

      padding: 15px 20px;
      h6 {
        font-size: 12px;
        margin: 0;
        color: #343a40;
      }
    }

    .manage-menu-list {
      list-style: none;
      padding: 0;
      li {
        padding: 7px 20px;
        font-weight: 400;
        color: #323a46;
        display: flex;
        align-items: center;
        cursor: pointer;
        gap: 8px;
        font-size: 14.4px;
        .v-icon {
          font-size: 16px;
        }
      }
    }
    .dropdown-divider {
      height: 0;
      margin: 0.75rem 0;
      overflow: hidden;
      border-top: 1px solid #eff1f4;
    }

    .scrollable-div {
      max-height: 40vh;
      overflow-y: auto;
    }
  }
}
</style>
